import { event } from '@blocket/tracking-pulse'
import gtm from '@blocket/tracking-gtm'
import log from 'sentry/log'

export const trackingError404page = () => {
  try {
    // view page should generally always have a gtm.pageView event as well. For marknad to use.
    gtm.pageView({ id: 'error-404' })

    event({
      type: 'View',
      name: 'View Error Page 404',
      object: {
        type: 'Page',
        id: 'error_404',
      },
    })
  } catch (error) {
    log.message(`Tracking error: View Error Page 404 ${error}`)
  }
}
